import { NavbarOptionButton } from "@/components/generic/SideNavBar/components/NavbarOptionButton/NavbarOptionButton"
import { IconChartBar, IconEye, IconMessageChatbot, IconRouteSquare } from "@tabler/icons-react"
import { WavingHandIcon } from "@/components/generic/WavingHandIcon"
import { Indicator, Text } from "@mantine/core"
import classes from "./NavbarOptionMessenger.module.css"
import { observer, useSelector } from "@legendapp/state/react"
import { chatStore$ } from "@/lib/ContactsMap"
import { usePathname } from "next/navigation"

interface NavbarOptionProps {
  isSelected: boolean
  label: string
}

export function NavbarOptionWelcome({ isSelected, label }: NavbarOptionProps) {
  return (
    <NavbarOptionButton
      icon={WavingHandIcon}
      isSelected={isSelected}
      label={label}
      href="/welcome"
      styles={{
        icon: {
          width: "55%",
          height: "55%",
        },
      }}
    />
  )
}

export const NavbarOptionMessenger = observer(function NavbarOptionMessenger({ isSelected, label }: NavbarOptionProps) {
  const pathname = usePathname()
  const unreadChats = useSelector(() => {
    const unreadNumber = Object.keys(chatStore$.unreadChats.get() ?? {}).length

    if (unreadNumber > 9) {
      return "+9"
    }

    return unreadNumber.toString()
  })

  return (
    <Indicator
      disabled={pathname.startsWith("/messenger") || unreadChats === "0"}
      inline
      label={
        <Text className={classes.indicatorLabel} size="xs">
          {unreadChats}
        </Text>
      }
      color="red"
      size={14}
      offset={4}
      withBorder
      classNames={{
        indicator: classes.indicator,
      }}
    >
      <NavbarOptionButton icon={IconMessageChatbot} isSelected={isSelected} label={label} href="/messenger" testID="sidenavbar-messenger-btn" />
    </Indicator>
  )
})

export function NavbarOptionStats({ isSelected, label }: NavbarOptionProps) {
  return <NavbarOptionButton icon={IconChartBar} isSelected={isSelected} label={label} href="/stats" />
}

export function NavbarOptionLiveMonitor({ isSelected, label }: NavbarOptionProps) {
  return <NavbarOptionButton icon={IconEye} isSelected={isSelected} label={label} href="/live-monitor" />
}

export function NavbarOptionSequences({ isSelected, label }: NavbarOptionProps) {
  return <NavbarOptionButton icon={IconRouteSquare} isSelected={isSelected} label={label} href="/sequences/library" />
}
